import { filterTypes } from '../reduxExports';

export const dashboardInitialFilterValues: InnerFilterState[] = [
  {
    key: 'chargerType',
    value: null
  },
  {
    key: 'severity',
    value: [
      {
        id: 'Critical',
        value: 'Critical',
        label: 'Critical',
        name: 'Critical'
      }
    ]
  }
]

export const dashboardV2InitialFilterValues: InnerFilterState[] = [
  {
    key: 'productType',
    value: null
  },
  {
    key: 'severity',
    value: [
      {
        id: 'Critical',
        value: 'Critical',
        label: 'Critical',
        name: 'Critical'
      }
    ]
  },
  {
    key: 'sessionIntervalRange',
    value: [
      {
        id: 'lastWeek',
        value: 'lastWeek',
        label: 'Last Week',
        name: 'Last Week'
      }
    ]
  },
  {
    key: 'keyType',
    value: [{
      'id': 'criticalAlarms',
      'value': 'criticalAlarms',
      'label': 'criticalAlarms',
      'name': 'criticalAlarms'
    }]
  },
  {
    key: 'chargingSessionFetchType',
    value: null
  },
  {
    key: 'energyConsumptionIntervalRange',
    value: [
      {
        id: 'lastWeek',
        value: 'lastWeek',
        label: 'Last Week',
        name: 'Last Week'
      }
    ]
  },
  {
    key: 'offlineFiveDays',
    value: [
      {
        id: 'false',
        value: 'false',
        label: 'false',
        name: 'false'
      }
    ]
  },
  {
    key: 'energyEfficiencyRange',
    value: [
      {
        id: 'lastWeek',
        value: 'lastWeek',
        label: 'Last Week',
        name: 'Last Week'
      }
    ]
  },
  {
    key: 'reactiveEnergyRange',
    value: [
      {
        id: 'lastWeek',
        value: 'lastWeek',
        label: 'Last Week',
        name: 'Last Week'
      }
    ]
  },
]


export const overallUptimeInitialFilterValues: InnerFilterState[] = [
  {
    key: 'chargerId',
    value: null
  },
  {
    key:'chargingStationId',
    value:null
  },
  {
    key: 'uptimeIntervalRange',
    value: [
      {
        id: 'lastWeek',
        value: 'lastWeek',
        label: 'Last Week',
        name: 'Last Week'
      }
    ]
  },
]
export const failedTransactionInitialFilterValues: InnerFilterState[] = [
  {
    key: 'chargerId',
    value: null
  },
  {
    key:'chargingStationId',
    value:null
  },
  {
    key: 'failedTransactionRange',
    value: [
      {
        id: 'lastWeek',
        value: 'lastWeek',
        label: 'Last Week',
        name: 'Last Week'
      }
    ]
  },
]
export const chargingSessionTrendInitialFilterValues: InnerFilterState[] = [
  {
    key: 'chargerId',
    value: null
  },
  {
    key:'chargingStationId',
    value:null
  },
  {
    key: 'sessionChargingIntervalRange',
    value: [
      {
        id: 'lastWeek',
        value: 'lastWeek',
        label: 'Last Week',
        name: 'Last Week'
      }
    ]
  },
]
export const chargingVsIdleInitialFilterValues: InnerFilterState[] = [
  {
    key: 'chargerId',
    value: null
  },
  {
    key:'chargingStationId',
    value:null
  },
  {
    key: 'idleChargingIntervalRange',
    value: [
      {
        id: 'lastWeek',
        value: 'lastWeek',
        label: 'Last Week',
        name: 'Last Week'
      }
    ]
  },
]

export const alarmInitialFilterValues: InnerFilterState[] = [
  {
    key: 'chargerType',
    value: null
  },
  {
    key: 'severity',
    value: null
  },
  {
    key: 'alarmSetTimeStamp',
    value: null
  },
  {
    key: 'alarmClearedTimeStamp',
    value: null
  },
  {
    key: 'alarmType',
    value: null
  },
  {
    key: 'chargerId',
    value: null
  },
  {
    key:'chargerStatus',
    value:null
  },
  {
    key:'alarmState',
    value:null
  }
]

export const alarmEventsInitialFilterValues: InnerFilterState[] = [
  {
    key: 'chargerType',
    value: null
  },
  {
    key: 'alarmEventSeverity',
    value: null
  },
  {
    key: 'alarmEventSetAtInterval',
    value: null
  },
  {
    key: 'alarmEventClearedAtInterval',
    value: null
  },
  {
    key: 'alarmEventType',
    value: null
  },
  {
    key: 'chargerId',
    value: null
  }
]

export const chargerInitialFilterValues: InnerFilterState[] = [
  {
    key: 'chargerType',
    value: null
  },
  {
    key: 'location',
    value: null
  },
  {
    key: 'chargerStatus',
    value: null
  },
  {
    key: 'softwareVersion',
    value: null
  },
  {
    key:'ccuVersion',
    value:null
  },
  {
    key: 'alarmStatus',
    value: null
  },
  {
    key: 'visibility',
    value: null
  },
  {
    key:'chargingStationId',
    value:null
  }  ,
  {
    key:'productType',
    value:null
  },
  {
    key:'activeCertificate',
    value:null
  }
]

export const parametersInitialFilterValues: InnerFilterState[] = [
  {
    key: 'param',
    value: null
  },
  {
    key: 'user',
    value: null
  },
  {
    key: 'setInterval',
    value: null
  },

]

export const chargingStationsInitialFilterValues: InnerFilterState[] = [
  {
    key: 'location',
    value: null
  },
]


export const customersInitialFilterValues: InnerFilterState[] = []

export const customerEditHistoryInitialFilterValues: InnerFilterState[] = [
  {
    key: 'updateInterval',
    value: null,
  }
]
export const chargingStationEditHistoryInitialFilterValues: InnerFilterState[] = [
  {
    key: 'stationUpdateInterval',
    value: null,
  }
]

export const customerChargerInitialFilterValues: InnerFilterState[] = [
  {
    key: 'location',
    value: null
  },
  {
    key: 'chargerStatus',
    value: null
  },
  {
    key: 'softwareVersion',
    value: null
  },
  {
    key: 'alarmStatus',
    value: null
  }
]

export const usersInitialFilterValues: InnerFilterState[] = [
  {
    key: 'orgName',
    value: null
  },
]

export const chargingHistoryReportInitialFilterValues: InnerFilterState[] = [
  {
    key:'chargingStationId',
    value:null
  },
  {
    key: 'chargerId',
    value: null,
  },
  {
    key:'stopReasonCode',
    value:null
  },
  {
    key: 'chargingHistoryInterval',
    value: null
  },
  {
    key:'productType',
    value:null
  },
]

export const chargerLogsReportInitialFilterValues: InnerFilterState[] = [
  {
    key: 'chargerId',
    value: null,
  },
  {
    key: 'chargerLogStatusInterval',
    value: null
  },
  {
    key: 'chargerLogSettingInterval',
    value: null
  },
  {
    key: 'chargerLogSystemLogInterval',
    value: null
  }
]

export const uptimeReportInitialFilterValues: InnerFilterState[] = [
  {
    key:'chargingStationId',
    value:null
  },
  {
    key:'productType',
    value:null
  },
  {
    key :'uptimeReportDateRangeInterval',
    value:null},
    {
      key:'uptimeQuickDateRange',
      value:[
    {
        label: 'Last Day',
        value: '24H'
    }
]
    }
]

export const exceptionLogsReportInitialFilterValues: InnerFilterState[] = [
  {
    key: 'chargerId',
    value: null,
  },
  {
    key: 'logSeverity',
    value: null
  },
  {
    key: 'logInterval',
    value: null
  }
]

export const sessionHistoryReportInitialFilterValues: InnerFilterState[] = [
  {
    key:'chargingStationId',
    value:null
  },
  {
    key: 'chargerId',
    value: null,
  },
  {
    key:'chargingSessionHistoryStopReason',
    value:null
  },
  {
    key: 'chargingSessionHistoryInterval',
    value: null
  },
  {
    key:'productType',
    value:null
  },
  {
    key:'plcLogFileStatus',
    value:null
  },
]

export const statusHistoryReportInitialFilterValues: InnerFilterState[] = [
  {
    key: 'chargerId',
    value: null,
  },
]

export const chargerPanelInitialFilterValues: InnerFilterState[] = [
  {
    key: 'historyType',
    value: null
  },
  {
    key: 'statType',
    value: null
  },
  {
    key: 'historyInterval',
    value: null

  },
  {
    key: 'statInterval',
    value: null
  },
  {
    key: 'connectorId',
    value: null
  }
]

export const configureNotificationInitialFilterValues: InnerFilterState[] = [
  {
    key: 'alarmSeverity',
    value: null
  },
  {
    key: 'alarmTypeId',
    value: null
  },
  {
    key: 'typeOfNotification',
    value: null
  },
  {
    key: 'stopReasonCode',
    value: null
  },
  {
    key: 'alarmRuleCreatedBy',
    value: null
  },
  {
    key: 'alarmRuleUpdatedBy',
    value: null
  },
  {
    key: 'alarmRuleCreatedAtInterval',
    value: null,
  },
  {
    key:'alarmRuleUpdatedAtInterval',
    value: null
  }
]

export const configureNotificationHistoryInitialFilterValues : InnerFilterState[] = [
  {
    key: 'chargingStationId',
    value: null,
  },
  { 
    key: 'ruleId',
    value: null,
  },
  {
    key: 'chargerId',
    value: null,
  },
  {
    key: 'alarmSeverity',
    value: null
  },
  {
    key: 'alarmTypeId',
    value: null,
  },
  {
    key: 'stopReasonCode',
    value: null
  },
  {
    key: 'typeOfNotification',
    value: null
  },
  {
    key: 'fireTime',
    value: null
  },
]

export const ruleEngineInitialFilterValues : InnerFilterState[] = [
  {
    key : 'triggerCategory',
    value: null,
  },
  {
    key : 'triggerLevel',
    value : null,
  },
  {
    key: 'actionControls',
    value: null,
  },
  {
    key: 'schedule',
    value: null,
  },
  {
    key:'ruleEngineChipStatus',
    value:null
  }
]
export const ruleEngineHistoryInitialFilterValues : InnerFilterState[] = [
  {
  key:'chargingStationId',
  value:null
  },
  {
  key:'chargerId',
  value:null
  },
  {
   key:'ruleEngineRuleName',
   value:null,
  },
  {
    key : 'triggerCategory',
    value: null,
  },
  {
    key : 'triggerLevel',
    value : null,
  },
  {
    key: 'actionControls',
    value: null,
  },
  {
    key: 'fireTimeRangeInterval',
    value: null,
  },
]
export const updateCommandslInitialFilterValues: InnerFilterState[] = [
  {
    key: 'userRemoteCommand',
    value: null
  },
  {
    key: 'setIntervalUpdateCommand',
    value: null
  },
]

export const executionSummaryRuleEngineFormInitialFilterValues: InnerFilterState[] = [
  {
    key:'chargingStationId',
    value:null
    },
    {
    key:'chargerId',
    value:null
    },
    {
      key : 'triggerCategory',
      value: null,
    },
    {
      key : 'triggerLevel',
      value : null,
    },
    {
      key: 'actionControls',
      value: null,
    },
    {
      key: 'fireTimeRangeInterval',
      value: null,
    },
]


export const versionReleasesInitialFilterValues: InnerFilterState[] = [
  {
    key:'versionProductType',
    value:null
  },
  {
    key:'versionSwType',
    value:null
  },
  {
    key:'versionReleaseType',
    value:null
  },
  {
    key:'versionSeverity',
    value:null
  },
  {
    key:'versionClassification',
    value:null
  },
  {
    key:'versionReleaseDateInterval',
    value:null
  }
]

export const versionReleasesDashboardInitialFilterValues:InnerFilterState[] = [
  {
    key:'productType',
    value:[
      {
        id:'717cd55b-99af-4e73-b6f7-e6c763919915',
        name:'EVM150',
        value:'717cd55b-99af-4e73-b6f7-e6c763919915',
        label:'EVM150'
      }
    ]
  },
  {
    key:'softwareVersion',
    value:null
  },
  {
    key:'swVersionDateInterval',
    value:[{
        id: 'lastQuarter',
        value: 'lastQuarter',
        label: 'Last Quarter',
        name: 'Last Quarter'
      }]
  },
  {
    key:'swVersionReleaseType',
    value:[
      {
        id:'Enabled',
        value:'Enabled',
        label:'Enabled',
        name:'Enabled'
      }
    ],
  },
  {
    key:'swVersionProductSubType',
    value:[
      {
        id:'all',
        name:'All',
        value:'All',
        label:'All'
      }
    ]
  },
  {
    key:'versionSwType',
    value:[
      {
        id:'upper',
        name:'Upper',
        value:'Upper',
        label:'Upper',
      }
    ]
  }
]

export const deploymentLogsDashboardInitialFilterValues:InnerFilterState[] = [
  {
    key:'productType',
    value:null
  },
  {
    key:'versionLogSwType',
    value:null
  },
  {
    key:'swLogStatus',
    value:null
  },
  {
    key:'chargingStationId',
    value:null
  },
  {
    key:'swVersionUpdateLogs',
    value:null
  },
  {
    key:'swVersionRequestedOnInterval',
    value:null
  },
]

export const nocDashboardInitialFilterValues:InnerFilterState[] = [
    {
    key: 'mapDefaultView',
    value:[
      {
        id:'chargingSessions',
        label:'chargingSessions',
        name:'chargingSessions',
        value:'chargingSessions'
      }
    ]
  },
  {
    key:'nocChargerStatus',
    value:[]
  },
  {
    key: 'nocChargerRmsStatus',
    value: []
  },
  {
    key: 'nocChargerCmsConnectivity',
    value: []
  },
  {
    key: 'nocChargerAlarms',
    value: []
  },
  {
    key: 'nocChargerChargingStatus',
    value: []
  },
  {
    key: 'nocAlarmHealthStatus',
    value:[]
  },
  {
    key: 'nocChargerHealthStatus',
    value: []
  },
  {
    key:'productType',
    value:null
  },
  {
    key:'timeSelection',
    value:null
  }
]

export const nocPerfomanceAnalyticsIntialFilterValues: InnerFilterState[] = [
  {
    key: 'chargingStationId',
    value: []
  },
  {
    key:'productType',
    value:[]
  },
  {
    key:'nocTimeSelectionInterval',
    value:[
       { label: 'Last 24hr', value: 'last24hr' }
    ]
  },
  {
    key:'chargerId',
    value:[]
  }
]

export const latestChargerStatusLogsInitialFilterValues:InnerFilterState[]=[
  {
  key:'chargerId',
  value:null
  },
]

export const rmsSupportAlarmTroubleshootingInititalFilterValues: InnerFilterState[] = [
  {
    key:'rmsSupportTroubleshootingAlarm',
    value: null,
  },
  {
    key:'rmsSupportTroubleshootingSeverity',
    value: null
  },
  {
    key: 'rmsSupportTroubleshootingProductType',
    value: null
  }
]

export const rmsSupportStopReasonCodeTroubleshootingInititalFilterValues: InnerFilterState[] = [
  {
    key:'rmsSupportTroubleshootingStopReasonCode',
    value: null,
  },
  {
    key:'rmsSupportTroubleshootingStoppedBy',
    value: null
  },
  {
    key: 'rmsSupportTroubleshootingProductType',
    value: null
  }
]

export const rmsSupportDocumentationInitialFilterValues: InnerFilterState [] = [
  {
    key:'rmsSupportDocumentType',
    value: null
  },
  {
    key:'rmsSupportDocumentVersion',
    value: null
  },
  {
    key: 'rmsSupportUploadedBy',
    value: null
  },
  {
    key: 'rmsSupportUploadedDateInterval',
    value: null
  },
  {
    key: 'rmsSupportDocumentUpdatedBy',
    value: null
  },
  {
    key: 'rmsSupportDocumentUpdatedAtInterval',
    value: null
  }

]

export const advanceRuleEngineInititalFilterValues: InnerFilterState [] = [
  {
    key:'advanceRuleEngineStatus',
    value: null
  },
  {
    key: 'advanceRuleEngineCreatedBy',
    value: null
  },
  {
    key: 'advanceRuleEngineUpdatedBy',
    value: null
  },
  {
    key: 'advanceRuleEngineCreatedAtInterval',
    value: null
  },
  {
    key: 'advanceRuleEngineUpdatedAtInterval',
    value: null
  }
]

export const advanceRuleEngineHistoryInititalFilterValues: InnerFilterState [] = [
  {
    key:'chargingStationId',
    value: null
  },
  {
    key: 'advaneRuleEngineRuleName',
    value: null
  },
  {
    key: 'chargerId',
    value: null
  },
  {
    key: 'advanceRuleEngineFireTimeRangeInterval',
    value: null
  }
]

export const derivedConditionsInititalFilterValues: InnerFilterState [] = [
  {
    key:'derivedConditionStatus',
    value: null
  },
  {
    key: 'derivedConditionCreatedBy',
    value: null
  },
  {
    key: 'derivedConditionUpdatedBy',
    value: null
  },
  {
    key: 'derivedConditionCreatedAtInterval',
    value: null
  },
  {
    key: 'derivedConditionUpdatedAtInterval',
    value: null
  }
]

export const advanceRuleExecutionSummaryInitialValues: InnerFilterState [] = [
  {
    key:'chargingStationId',
    value: null
  },
  {
    key: 'chargerId',
    value: null
  },
  {
    key: 'advanceRuleEngineFireTimeRangeInterval',
    value: null
  }
]

export const advanceRuleTriggerLogsInitialValues: InnerFilterState [] = [
  {
    key: 'chargerId',
    value: null
  },
  {
    key: 'advanceRuleTriggerLogsTimeRangeInterval',
    value: null
  }
]

export const chargerCertificatesInfoInitialValues: InnerFilterState [] = [
  {
    key:'chargingStationId',
    value: null
  },
  {
    key: 'chargerId',
    value: null
  },
  {
    key: 'certificateGeneretedBy',
    value: null
  },
  {
    key: 'certificateCreatedAtInterval',
    value: null
  },
  {
    key: 'certificateExpiryIntervalRange',
    value: null
  },
  {
    key: 'chargerCertificateStatus',
    value: null
  },
  {
    key: 'productType',
    value: null
  },
]

export const adminPasswordUpdateLogsFilterInitialValues: InnerFilterState [] = [
  {
    key: 'chargerId',
    value: null
  },
  {
    key: 'adminPasswordUpdateStatus',
    value: null
  },
  {
    key: 'adminPasswordUpdateRequestedOn',
    value: null
  }
]

export const inventoryParamsChangeLogsFilterInitialValues: InnerFilterState [] = [
  {
    key: 'changeLogFieldName',
    value: null
  },
  {
    key: 'changeLogChangeType',
    value: null
  },
  {
    key: 'changeLogLoggedAt',
    value: null
  },
]

export const inventoryParamsHistoryReportFilterInitialValues: InnerFilterState [] = [
  {
    key: 'chargerId',
    value: null
  },
  {
    key: 'productType',
    value: null
  },
  {
    key: 'inventoryParamComponentType',
    value: null
  },
  {
    key: 'inventoryParamHistoryDateRange',
    value: null
  },
]

export const inventoryParamsLatestLogsReportFilterInitialValues: InnerFilterState [] = [
  {
    key: 'chargerId',
    value: null
  },
  {
    key: 'productType',
    value: null
  },
  {
    key: 'inventoryParamComponentType',
    value: null
  }
]

export const inventoryParamsChangeLogsReportFilterInitialValues: InnerFilterState [] = [
  {
    key: 'chargerId',
    value: null
  },
  {
    key: 'productType',
    value: null
  },
  {
    key: 'inventoryParamComponentType',
    value: null
  },
  {
    key: 'changeLogFieldName',
    value: null
  },
  {
    key: 'changeLogChangeType',
    value: null
  },
  {
    key: 'changeLogLoggedAt',
    value: null
  },
]

export const screenFiltersInitialState: ScreenFilterState[] = [
  {
    screen: 'dashboard',
    filters: dashboardInitialFilterValues
  },
  {
    screen: 'dashboardV2',
    filters: dashboardV2InitialFilterValues
  },
  {
    screen:'overallUptime',
    filters:overallUptimeInitialFilterValues
  },
  {
    screen:'failedTransaction',
    filters:failedTransactionInitialFilterValues
  },
  {
    screen:'chargingSessionTrend',
    filters:chargingSessionTrendInitialFilterValues
  },
  {
    screen:'chargingVsIdle',
    filters:chargingVsIdleInitialFilterValues
  },
  {
    screen: 'chargers',
    filters: chargerInitialFilterValues
  },
  {
    screen: 'alarms',
    filters: alarmInitialFilterValues
  },
  {
    screen: 'alarmEvents',
    filters: alarmEventsInitialFilterValues
  },
  {
    screen: 'parameters',
    filters: parametersInitialFilterValues
  },
  {
    screen: 'chargingStations',
    filters: chargingStationsInitialFilterValues
  },
  {
    screen: 'customerCharger',
    filters: customerChargerInitialFilterValues
  },
  {
    screen: 'chargingHistoryReport',
    filters: chargingHistoryReportInitialFilterValues
  },
  {
    screen: 'chargerLogsReport',
    filters: chargerLogsReportInitialFilterValues
  },
  {
    screen: 'customerEditHistory',
    filters: customerEditHistoryInitialFilterValues
  },
  {
     screen: 'chargingStationEditHistory',
     filters:chargingStationEditHistoryInitialFilterValues
  },
  {
    screen: 'customers',
    filters: customersInitialFilterValues
  },
  {
    screen: 'users',
    filters: usersInitialFilterValues
  },
  {
    screen: 'chargerPanel',
    filters: chargerPanelInitialFilterValues
  },
  {
    screen: 'exceptionLogsReport',
    filters: exceptionLogsReportInitialFilterValues
  },
  {
    screen:'uptimeReports',
    filters:uptimeReportInitialFilterValues
  },
  {
    screen:'sessionHistoryReport',
    filters: sessionHistoryReportInitialFilterValues
  },
  {
    screen: 'statusHistoryReport',
    filters: statusHistoryReportInitialFilterValues
  },
  {
    screen: 'configureNotification',
    filters: configureNotificationInitialFilterValues
  },
  {
    screen: 'configureNotificationHistory',
    filters: configureNotificationHistoryInitialFilterValues
  },
  {
    screen: 'ruleEngine',
    filters: ruleEngineInitialFilterValues
  },
  {
    screen: 'ruleEngineHistory',
    filters: ruleEngineHistoryInitialFilterValues
  },
  {
    screen: 'updateCommands',
    filters: updateCommandslInitialFilterValues
  },
  {
    screen: 'executionSummaryRuleEngineForm',
    filters: executionSummaryRuleEngineFormInitialFilterValues
  },
  {
    screen: 'versionReleases',
    filters: versionReleasesInitialFilterValues
  },
  {
    screen:'versionReleasesDashboard',
    filters:versionReleasesDashboardInitialFilterValues
  },
  {
    screen:'softwareVersionDeploymentLogs',
    filters:deploymentLogsDashboardInitialFilterValues
  },
  {
    screen:'nocDashboard',
    filters:nocDashboardInitialFilterValues
  },
  {
    screen:'nocPerfomanceAnalytics',
    filters:nocPerfomanceAnalyticsIntialFilterValues
  },
  {
    screen:'latestChargerStatusLogs',
    filters:latestChargerStatusLogsInitialFilterValues
  },
  {
    screen: 'rmsSupportAlarmTroubleshooting',
    filters: rmsSupportAlarmTroubleshootingInititalFilterValues
  },
  {
    screen:'rmsSupportStopReasonCodeTroubleshooting',
    filters: rmsSupportStopReasonCodeTroubleshootingInititalFilterValues
  },
  {
    screen: 'rmsSupportDocumentation',
    filters: rmsSupportDocumentationInitialFilterValues
  },
  {
    screen: 'advanceRuleEngine',
    filters: advanceRuleEngineInititalFilterValues
  },
  {
    screen: 'advanceRuleEngineHistory',
    filters: advanceRuleEngineHistoryInititalFilterValues
  },
  {
    screen: 'derivedConditions',
    filters: derivedConditionsInititalFilterValues
  },
  {
    screen: 'advanceRuleExecutionSummary',
    filters: advanceRuleExecutionSummaryInitialValues
  },
  {
    screen: 'advanceRuleTriggerLogs',
    filters: advanceRuleTriggerLogsInitialValues
  },
  {
    screen: 'chargerCertificates',
    filters: chargerCertificatesInfoInitialValues
  },
  {
    screen: 'adminPasswordUpdateLogs',
    filters: adminPasswordUpdateLogsFilterInitialValues
  },
  {
    screen: 'inventoryParamChangeLogs',
    filters: inventoryParamsChangeLogsFilterInitialValues
  },
  {
    screen: 'inventoryParamHistoryReport',
    filters: inventoryParamsHistoryReportFilterInitialValues
  },
  {
    screen: 'inventoryParamLatestLogsReport',
    filters: inventoryParamsLatestLogsReportFilterInitialValues
  },
  {
    screen: 'inventoryParamChangeLogsReport',
    filters: inventoryParamsChangeLogsReportFilterInitialValues
  }
]


export const globalFiltersInitialState: InnerFilterState[] = [
  {
    key: 'customer',
    value: null
  },
]

const filterInitialState: FilterDataState = {
  globalFilters: globalFiltersInitialState,
  screenFilters: screenFiltersInitialState,
};

const filterReducer = (state: FilterDataState = filterInitialState, action: FilterDataAction): FilterDataState => {
  switch (action.type) {
    case filterTypes.SET_GLOBAL_FILTERS_DATA:
      return {
        ...state,
        globalFilters: action.globalFilters,
      };

    case filterTypes.SET_SCREEN_FILTERS_DATA:
      return {
        ...state,
        screenFilters: action.screenFilters,
      };
    default:
      return state;
  }
};


export default filterReducer;